module.exports = __webpack_public_path__ + "static/media/photo-1535958636474-b021ee887b13.26ff4434.jpg";